/* @flow */

import * as React from 'react';
import {FeatureUsageBox} from './feature-usage-box';

import './feature-usage.css';

type Props = {
    currentUsage: number,
    currentPlanMaxUsage: ?number,
    nextPlanMaxUsage: ?number,
};

export function FeatureUsage(props: Props) {
    return (
        <div styleName='feature-usage'>
            <FeatureUsageBox
                isCurrentPlan={true}
                currentUsage={props.currentUsage}
                maxUsage={props.currentPlanMaxUsage}
            />
            <FeatureUsageBox
                isCurrentPlan={false}
                currentUsage={props.currentUsage}
                maxUsage={props.nextPlanMaxUsage}
            />
        </div>
    );
}
